import { Link, NavLink } from "react-router-dom";
import { Icon } from "../Icon";
import { AthenaeumMark } from "../../design-system/components";
import { useNotifications } from "../../hooks/NotificationsContext";

export function ActivityRail({
  signedIn,
  username,
  open,
  onClose,
}: {
  signedIn: boolean;
  username?: string;
  open: boolean;
  onClose: () => void;
}) {
  const { unread = 0 } = useNotifications();
  const links = [
    ["/", "Home", "home"],
    ["/explore", "Explore", "globe"],
    ["/explore/people", "People", "user"],
    ...(signedIn
      ? ([
          ["/settings/following", "Following", "chat"],
          ["/notifications", "Notifications", "bell"],
          ["/settings/wikis", "Your wikis", "book"],
          ["/settings/starred", "Saved wikis", "star"],
        ] as const)
      : []),
  ] as const;
  return (
    <aside
      id="library-navigation"
      className={`activity-rail${open ? " is-open" : ""}`}
    >
      <Link className="rail-brand" to="/" aria-label="Athenaeum Library home">
        <AthenaeumMark />
      </Link>
      <button
        className="btn ghost icon-btn rail-close"
        aria-label="Close navigation"
        onClick={onClose}
      >
        <Icon name="close" />
      </button>
      <nav aria-label="Main navigation">
        {links.map(([to, label, icon]) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/" || to === "/explore"}
            title={label}
            aria-label={
              to === "/notifications" && unread
                ? `Notifications, ${unread} unread`
                : label
            }
            onClick={onClose}
          >
            <Icon name={icon} />
            <span>{label}</span>
            {to === "/notifications" && unread > 0 && <small>{unread}</small>}
          </NavLink>
        ))}
      </nav>
      <div className="rail-spacer" />
      <nav aria-label="Personal navigation">
        {signedIn && (
          <NavLink to={`/user/${username}`} onClick={onClose}>
            <Icon name="user" />
            <span>Profile</span>
          </NavLink>
        )}
        <NavLink
          to={signedIn ? "/settings" : "/explore/preferences"}
          onClick={onClose}
        >
          <Icon name="settings" />
          <span>Settings</span>
        </NavLink>
      </nav>
      <Link className="btn rail-share" to="/explore/guide" onClick={onClose}>
        <Icon name="plus" />
        <span>Share a local wiki</span>
      </Link>
    </aside>
  );
}
